export default __webpack_public_path__ + "static/media/login-bg-19.2a588c8e.jpg";